import React from "react";
import PropTypes from "prop-types";
import WelcomeMat from "../WelcomeMat";
import WelcomeMessage from "../WelcomeMessage";

const WelcomeWrapper = ({ useWelcomeMat }) => {
  return useWelcomeMat ? <WelcomeMat /> : <WelcomeMessage />;
};

WelcomeWrapper.propTypes = {
  useWelcomeMat: PropTypes.bool
};

export default WelcomeWrapper;



// WEBPACK FOOTER //
// ./template/components/WelcomeWrapper/WelcomeWrapper.js